import SaveButton from 'components/buttons/SaveButton';
import SelectInput from 'components/input-field/SelectInput';
import TextInput from 'components/input-field/TextInput'
import { Form, Formik } from 'formik';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { Col, Row } from 'reactstrap';
import Loader from 'components/loader/Loader';
import { designationSchema } from './Validation';
import { AddDesignationRes, addDesignationTodo } from 'redux/slice/super-admin/master/designation/AddDesignation';

class AddDesignationForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            spiner: false,
            values: {
                designation: '',
                status: ''
            }
        };
    }

    status_option = [
        { "value": 'Active', "label": "Active" },
        { "value": 'Inactive', "label": "Inactive" }
    ]

    handleSubmit = (values) => {
        this.setState({ spiner: true });
        const { dispatch } = this.props;
        dispatch(addDesignationTodo(values)).then(() => this.add_res());

    }


    add_res = () => {
        if (AddDesignationRes?.success) {
            toast.success(AddDesignationRes?.message, { position: "bottom-right" });
            setTimeout(() => {
                this.props.history.push('/superadmin/designation-list');
            }, 1200);
            this.setState({ spiner: false });
        } else {
            toast.error(AddDesignationRes?.message, { position: "bottom-right" });
            this.setState({ spiner: false });
        }
    }

    render() {
        return (
            <>
                <div className='form_layout'>
                    {this.state.spiner ?
                        <div className='d-flex justify-content-center p-5'>
                            <Loader />
                        </div> :

                        <Formik
                            initialValues={this.state.values}
                            validationSchema={designationSchema}
                            onSubmit={this.handleSubmit}
                        >
                            {({
                                values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                                <Form>
                                    <Row>
                                        <Col xl='4'>
                                            <TextInput
                                                label_name='Designation'
                                                placeholder=''
                                                name='designation'
                                                value={values.designation || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.designation && touched.designation ? (<span className='text-danger form_label' >{errors.designation}</span>) : null}
                                            />
                                        </Col>
                                        <Col xl='4'>
                                            <SelectInput
                                                closeMenu={true}
                                                label_name='Status'
                                                disabled={false}
                                                options={this.status_option}
                                                name='status'
                                                defaultValue={''}
                                                onChange={(e) =>
                                                    setFieldValue('status', e.value)
                                                }
                                                onBlur={handleBlur}
                                                error={errors.status && touched.status ? (<span className='text-danger form_label' >{errors.status}</span>) : null} />
                                        </Col>
                                        <Col xl='12' className='d-flex justify-content-end'>
                                            <SaveButton name={'SAVE'} />
                                        </Col>
                                    </Row>
                                </Form>
                            )}
                        </Formik>
                    }
                </div>
                <ToastContainer />

            </>
        )
    }
}
export default connect()(withRouter(AddDesignationForm));
